import { useState, useEffect, useRef, useMemo } from "react";
import "../styles/Pms.css";
import { useNavigate, Navigate, useLocation } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import LoadingScreen from "../components/LoadingScreen";
import { WISDOM_PMS_AR_LIST, WISDOM_PMS_CATEGORY_GRADIANT, WISDOM_PMS_CATEGORY_ICON, WISDOM_PMS_EN_LIST, WISDOM_PMS_ROLE_PERMISSION, WSIDOM_PMS_FORMS_ORDER } from "../constants/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import DenyAccessPage from "../components/DenyAccessPage";
import { fetchWisdomForms } from "services/wisdom/wisdomData";
import { useTheme } from "context/ThemeContext";
import ModernBackground from "components/ui/ModernBackground";
import ModelNaviagtionSideBar from "components/ui/ModelNavigationSideBar";
import WisdomNavbar from "components/navbars/WisdomNabvar";

const Pms = () => {
  const { userInfo } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { language } = useLanguage();
  const { darkMode } = useTheme();
  const focusedCardRef = useRef(null);
  const [forms, setForms] = useState([]);
  const [dailyOperations, setDailyOperations] = useState([]);
  const [search,] = useState("");
  const [focusedCardId, setFocusedCardId] = useState(null);
  const [focusExit, setFocusExit] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // still havent fully cleaned
  // Fetching all forms
  useEffect(() => {
    const loadForms = async () => {
      try {
        const response = await fetchWisdomForms();

        const groupedData = [];

        response.forEach((item) => {
          // split the form's code 
          const codePermission = item.code.split(" | ")[0];
          const codeKey2 = item.code.split(" | ")[1];
          const codePermission2 = WISDOM_PMS_ROLE_PERMISSION[codePermission] || null;
          const codeKey = WISDOM_PMS_EN_LIST[codeKey2] || null;
          const codeAr = WISDOM_PMS_AR_LIST[codeKey2] || null;
          const codeKey3 = WISDOM_PMS_ROLE_PERMISSION[codeKey2] || null;
          if (codePermission2 === userInfo.user_role || (codeKey2 === "DO" && userInfo.user_role === "Supervisor") || (codeKey2 === "DO" && userInfo.user_role === "Social Worker") || (codePermission2 === "Employee" && userInfo.user_role !== "Student") || (codePermission2 === "Self" && codeKey === userInfo.user_role) || (codePermission2 === "Self" && codeKey === "Teacher" && userInfo.user_role === "Head of Department (HOD)") || (codePermission === "Cl" && userInfo.user_role === "Head of Department (HOD)") || userInfo.user_role === "Operations Excellence Lead" || userInfo.user_role === "Super Admin") {
            let existingGroup = groupedData.find(
              (group) => group.code === codeKey
            );

            if (!existingGroup) {
              existingGroup = {
                id: item.id,
                code: codeKey,
                reviewee: codeKey3,
                codeAr: codeAr,
                forms: [],
              };
              groupedData.push(existingGroup);
            }

            existingGroup.forms.push({
              id: item.id,
              en_name: item.en_name,
              ar_name: item.ar_name,
              permission: codePermission2,
            });
          }
        });

        const generalForms = groupedData.filter(
          (filteredData) => filteredData.code !== "PD"
        );
        const filteredGeneralForms = generalForms.filter(
          (filteredData) => filteredData.code !== "Daily Operations"
        );

        const filter2 = groupedData.filter(
          (testData) => testData.code === "Daily Operations"
        );

        const formsOrder = [6, 15, 9, 1, 18, 31, 22];

        const newForms = WSIDOM_PMS_FORMS_ORDER
          .map((id) => filteredGeneralForms[id])
          .filter((f) => f !== undefined);

        // Sort newForms according to formsOrder array
        const orderedForms = newForms.sort((a, b) => {
          const indexA = formsOrder.indexOf(a.id);
          const indexB = formsOrder.indexOf(b.id);

          // Forms not in formsOrder go to the end
          const safeIndexA = indexA === -1 ? formsOrder.length : indexA;
          const safeIndexB = indexB === -1 ? formsOrder.length : indexB;

          return safeIndexA - safeIndexB;
        });
        setForms(orderedForms);
        setDailyOperations(filter2);
      } catch (err) {
        console.error("API Error:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    loadForms();
  }, [userInfo]);

  // Memoize filtered forms to prevent recalculation on every render
  const filteredForms = useMemo(() => {
    return forms.map(type => ({
      ...type,
      forms: type.forms.filter(form => {
        const name = language ? form.en_name : form.ar_name;
        return name.toLowerCase().includes(search.toLowerCase());
      })
    })).filter(type => type.forms.length > 0);
  }, [forms, search, language]);

  // Escape key support to exit focus mode
  useEffect(() => {
    if (!focusedCardId) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') handleFocusExit();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [focusedCardId]);

  // navigation for normal form
  const handleClick = (id, en_name, ar_name, code, reviewee) => {
    navigate(`/pms/form/${id}`, {
      state: { formEnName: en_name, formArName: ar_name, code, reviewee },
    });
  };

  // navigation for teacher substitution form
  const handleTeacherSubstitutionClick = () => {
    navigate(`/pms/teacher-substitutions`);
  };

  // navigation for teacher latness form
  const handleTeacherLatnessClick = () => {
    navigate(`/pms/teacher-latness`);
  };

  // navigation for student attendance form
  const handleStudentAbsenceClick = () => {
    navigate(`/pms/student-absence`);
  };

  // navigation for school incident form
  const handleSchoolIncidentClick = () => {
    navigate(`/pms/school-incident`);
  };

  // navigation for interview form
  const handleInterviewClick = () => {
    navigate(`/pms/interview`);
  };

  // navigation for student behavior form
  const handleStudentBehaviorClick = () => {
    navigate(`/pms/student-behavior`);
  };

  // navigation for create new grade book form
  const handleCreateGradebookClick = () => {
    navigate(`/pms/create-gradebook`);
  };

  // navigation for insert grade book scores form
  const handleInsertGradebookScoresClick = () => {
    navigate(`/pms/insert-gradebook-scores`);
  };

  // Handle focus exit with animation
  const handleFocusExit = () => {
    setFocusExit(true);
    setTimeout(() => {
      setFocusedCardId(null);
      setFocusExit(false);
    }, 400); // match exit animation duration
  };

  // clean these later
  if (loading) return <LoadingScreen />;
  if (error?.status === 403) return <Navigate to="/" state={{ from: location }} replace />;
  if (error) { return userInfo?.code === 3 ? <p>Error: {error.message}</p> : <Navigate to="/" />;
  } if (userInfo?.code === 1452 || userInfo?.code === 1476) return <DenyAccessPage homePage='/watoms/dashboard' />;
  if (userInfo?.code === 1475) return <DenyAccessPage homePage='/watoms/news' />;
  if (userInfo?.code === 1310) return <DenyAccessPage homePage='/wisdom/dashboard' />;

  return (
    <div className={`min-h-screen w-full font-[Cairo,sans-serif] transition-colors duration-500 ${darkMode ? 'bg-watomsBlue text-white' : 'bg-gradient-to-br from-blue-50 via-white to-purple-100 text-gray-900'} relative`}>
      <ModernBackground />

      <div className="w-full flex">
        <ModelNaviagtionSideBar />
        {/* Main Code */}
        <div className="flex flex-col items-center justify-center min-h-[80vh] w-full relative z-10">
          {/* Navbar */}
          <WisdomNavbar />
          {/* Main Body */}
          <div className="w-full max-w-6xl mx-auto mt-4">
            {/* Title */}
            <h2 className="text-3xl font-extrabold mb-2 text-center bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 bg-clip-text text-transparent">
              {language ? 'Performance Categories' : 'الفئات المستهدفة'}
            </h2>
            {/* underline for the title */}
            <div className="mx-auto mb-10 mt-2" style={{ height: '3px', width: '180px', background: 'linear-gradient(90deg,#a259f7 0%,#667eea 100%)', borderRadius: '2px', opacity: 0.18 }} />
            {/* Forms Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
              {filteredForms.map((category, idx) => (
                <div
                  key={category.id}
                  className="group relative bg-gradient-to-br from-gray-50 to-white rounded-xl p-6 cursor-pointer hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-blue-200 hover:scale-105 card-hover-lift"
                  onClick={() => setFocusedCardId(category.id)}
                >
                  {/* Category Icon */}
                  <div className="flex items-center justify-between mb-4">
                    <div className={`w-12 h-12 rounded-xl flex items-center justify-center text-white text-xl font-bold bg-gradient-to-br ${WISDOM_PMS_CATEGORY_GRADIANT(category.code)}`}>
                      <FontAwesomeIcon icon={WISDOM_PMS_CATEGORY_ICON(category.code)} />
                    </div>
                    <div className="text-right">
                      <span className="bg-blue-100 text-blue-800 text-xs font-bold px-2 py-1 rounded-full">
                        {category.forms.length} {language ? 'forms' : 'نموذج'}
                      </span>
                    </div>
                  </div>
                  {/* Category Title */}
                  <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors">
                    {language ? category.code : category.codeAr}
                  </h3>
                  {/* Category Description */}
                  <p className="text-sm text-gray-600 mb-4 line-clamp-2">
                    {language ? category.description || 'Performance management category' : category.descriptionAr || 'فئة إدارة الأداء'}
                  </p>
                  {/* Hover Effect */}
                  <div className="absolute inset-0 bg-gradient-to-r from-blue-500/5 to-purple-500/5 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  {/* Click Indicator */}
                  <div className="absolute bottom-4 right-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                    <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
                      <FontAwesomeIcon icon={faArrowRight} className="text-white text-sm" />
                    </div>
                  </div>
                  {/* Form Count Badge */}
                  <div className="absolute top-4 right-4">
                    <div className="w-6 h-6 bg-orange-500 text-white rounded-full flex items-center justify-center text-xs font-bold">
                      {category.forms.length}
                    </div>
                  </div>
                </div>
              ))}
              {dailyOperations.map((category, idx) => (
                <div
                  key={category.id}
                  className="group relative bg-gradient-to-br from-gray-50 to-white rounded-xl p-6 cursor-pointer hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-blue-200 hover:scale-105 card-hover-lift"
                  onClick={() => setFocusedCardId(category.id)}
                >
                  {/* Category Icon */}
                  <div className="flex items-center justify-between mb-4">
                    <div className={`w-12 h-12 rounded-xl flex items-center justify-center text-white text-xl font-bold bg-gradient-to-br ${WISDOM_PMS_CATEGORY_GRADIANT(category.code)}`}>
                      <FontAwesomeIcon icon={WISDOM_PMS_CATEGORY_ICON(category.code)} />
                    </div>
                    <div className="text-right">
                      <span className="bg-blue-100 text-blue-800 text-xs font-bold px-2 py-1 rounded-full">
                        6 {language ? 'forms' : 'نموذج'}
                      </span>
                    </div>
                  </div>
                  {/* Category Title */}
                  <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors">
                    {language ? category.code : category.codeAr}
                  </h3>
                  {/* Category Description */}
                  <p className="text-sm text-gray-600 mb-4 line-clamp-2">
                    {language ? category.description || 'Performance management category' : category.descriptionAr || 'فئة إدارة الأداء'}
                  </p>
                  {/* Hover Effect */}
                  <div className="absolute inset-0 bg-gradient-to-r from-blue-500/5 to-purple-500/5 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  {/* Click Indicator */}
                  <div className="absolute bottom-4 right-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                    <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
                      <FontAwesomeIcon icon={faArrowRight} className="text-white text-sm" />
                    </div>
                  </div>
                  {/* Form Count Badge */}
                  <div className="absolute top-4 right-4">
                    <div className="w-6 h-6 bg-orange-500 text-white rounded-full flex items-center justify-center text-xs font-bold">
                      6
                    </div>
                  </div>
                </div>
              ))}
              {/* Student Behavior Card */}
              <div
                key="behavior"
                className="group relative bg-gradient-to-br from-gray-50 to-white rounded-xl p-6 cursor-pointer hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-blue-200 hover:scale-105 card-hover-lift"
                onClick={() => setFocusedCardId("behavior")}
              >
                {/* Category Icon */}
                <div className="flex items-center justify-between mb-4">
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center text-white text-xl font-bold bg-gradient-to-br ${WISDOM_PMS_CATEGORY_GRADIANT("behavior")}`}>
                    <FontAwesomeIcon icon={WISDOM_PMS_CATEGORY_ICON("behavior")} />
                  </div>
                  <div className="text-right">
                    <span className="bg-blue-100 text-blue-800 text-xs font-bold px-2 py-1 rounded-full">
                      1 {language ? 'forms' : 'نموذج'}
                    </span>
                  </div>
                </div>
                {/* Category Title */}
                <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors">
                  {language ? "Student Behavior" : "سلوك الطالب"}
                </h3>
                {/* Category Description */}
                <p className="text-sm text-gray-600 mb-4 line-clamp-2">
                  {language ? 'Performance management category' : 'فئة إدارة الأداء'}
                </p>
                {/* Hover Effect */}
                <div className="absolute inset-0 bg-gradient-to-r from-blue-500/5 to-purple-500/5 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                {/* Click Indicator */}
                <div className="absolute bottom-4 right-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                  <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
                    <FontAwesomeIcon icon={faArrowRight} className="text-white text-sm" />
                  </div>
                </div>
                {/* Form Count Badge */}
                <div className="absolute top-4 right-4">
                  <div className="w-6 h-6 bg-orange-500 text-white rounded-full flex items-center justify-center text-xs font-bold">
                    1
                  </div>
                </div>
              </div>
              {/* Grade Book Card */}
              {(userInfo?.organization_id === 13 || userInfo?.user_role === "Teacher") && <div
                key="gradebook"
                className="group relative bg-gradient-to-br from-gray-50 to-white rounded-xl p-6 cursor-pointer hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-blue-200 hover:scale-105 card-hover-lift"
                onClick={() => setFocusedCardId("gradebook")}
              >
                {/* Category Icon */}
                <div className="flex items-center justify-between mb-4">
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center text-white text-xl font-bold bg-gradient-to-br ${WISDOM_PMS_CATEGORY_GRADIANT("gradebook")}`}>
                    <FontAwesomeIcon icon={WISDOM_PMS_CATEGORY_ICON("gradebook")} />
                  </div>
                  <div className="text-right">
                    <span className="bg-blue-100 text-blue-800 text-xs font-bold px-2 py-1 rounded-full">
                      2 {language ? 'forms' : 'نموذج'}
                    </span>
                  </div>
                </div>
                {/* Category Title */}
                <h3 className="text-lg font-bold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors">
                  {language ? "Grade Book" : "سجل التقييم"}
                </h3>
                {/* Category Description */}
                <p className="text-sm text-gray-600 mb-4 line-clamp-2">
                  {language ? 'Grade Book' : 'سجل التقييم'}
                </p>
                {/* Hover Effect */}
                <div className="absolute inset-0 bg-gradient-to-r from-blue-500/5 to-purple-500/5 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                {/* Click Indicator */}
                <div className="absolute bottom-4 right-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                  <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
                    <FontAwesomeIcon icon={faArrowRight} className="text-white text-sm" />
                  </div>
                </div>
                {/* Form Count Badge */}
                <div className="absolute top-4 right-4">
                  <div className="w-6 h-6 bg-orange-500 text-white rounded-full flex items-center justify-center text-xs font-bold">
                    2
                  </div>
                </div>
              </div>}
            </div>
          </div>
        </div>
      </div>
      {/* Form's Categories Popup */}
      {focusedCardId && (
        <div className="fixed inset-0 z-40 flex items-center justify-center">
          <div className="absolute inset-0 bg-black/60 backdrop-blur-[6px] transition-all duration-500 animate-fadeIn" onClick={focusExit ? undefined : handleFocusExit} />
          <div className="flex flex-col w-full max-w-[700px] min-h-[400px] max-h-[80vh] bg-white/30 backdrop-blur-xl shadow-2xl border border-white/50 rounded-3xl z-50 relative p-0 overflow-hidden" style={{ margin: '2vh auto', boxSizing: 'border-box' }}>
            {/* Sticky Glassy Header */}
            <div className="sticky top-0 z-10 flex items-center justify-between w-full px-6 py-3 bg-white/40 backdrop-blur-lg border-b border-white/30" style={{ backdropFilter: 'blur(16px)' }}>
              <button
                className="px-5 py-2 rounded-full bg-gradient-to-r from-blue-500 to-purple-600 text-white font-bold shadow-md hover:shadow-lg transition-all duration-300 flex items-center gap-2 group z-50 text-base"
                onClick={() => {
                  setFocusedCardId(null);
                }}
                disabled={focusExit}
              >
                <FontAwesomeIcon icon={faArrowRight} className="text-base group-hover:translate-x-1 transition-transform" />
                {language ? 'Back to Categories' : 'العودة للفئات'}
              </button>
            </div>
            {/* each type of categories */}
            <div className="flex-1 overflow-y-auto w-full pt-4 px-6 pb-6 scrollbar-thin scrollbar-thumb-blue-200 scrollbar-track-transparent" style={{ scrollbarWidth: 'thin' }}>
              {filteredForms.filter(type => type.id === focusedCardId).map(type => (
                <div
                  key={type.id}
                  ref={focusedCardRef}
                  className={`focused-card-true relative rounded-2xl border border-white/30 bg-gradient-to-br from-white/60 via-blue-100/60 to-white/40 shadow-xl flex flex-col min-w-0 w-full animate-fadeInUp mb-4`}
                  style={{ padding: '1.25rem', alignSelf: 'center', zIndex: 50, pointerEvents: focusExit ? 'none' : 'auto', opacity: focusExit ? 0.7 : 1, backdropFilter: 'blur(10px)' }}
                >
                  {/* Category Header */}
                  <div className="flex items-center gap-3 mb-4">
                    <div className="relative">
                      <div className="w-12 h-12 bg-gradient-to-br from-blue-400/40 to-purple-400/40 backdrop-blur-md rounded-xl flex items-center justify-center shadow border border-white/30">
                        <FontAwesomeIcon icon={WISDOM_PMS_CATEGORY_ICON(type.code)} className="text-2xl text-blue-700 drop-shadow-lg" />
                      </div>
                      <div className="absolute -top-2 -right-2 w-6 h-6 bg-gradient-to-br from-orange-400 to-red-500 rounded-full flex items-center justify-center border border-white shadow animate-pulse">
                        <span className="text-white text-xs font-bold">{type.forms.length}</span>
                      </div>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-bold tracking-wide text-blue-900 mb-1 drop-shadow-lg bg-gradient-to-r from-blue-900 to-purple-700 bg-clip-text text-transparent">
                        {language ? type.code : type.codeAr}
                      </h3>
                      <p className="text-xs text-blue-900/80 font-medium leading-relaxed mb-1">
                        {type.description || (language ? 'View and manage forms for this category.' : 'عرض وإدارة النماذج لهذا التصنيف.')}
                      </p>
                    </div>
                  </div>
                  {/* Forms Grid */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {type.forms.map((form, idx) => (
                      <div
                        key={form.id}
                        className="group bg-white/80 backdrop-blur rounded-xl shadow-lg border border-white/40 px-4 py-4 hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 animate-fadeInUp cursor-pointer hover:border-blue-400/60 flex flex-col"
                        style={{ animationDelay: `${idx * 80}ms` }}
                        onClick={() => handleClick(form.id, form.en_name, form.ar_name, form.permission, type.reviewee)}
                      >
                        {/* Form Header */}
                        <div className="flex items-center gap-2 mb-4">
                          <div className="w-8 h-8 bg-gradient-to-br from-blue-500 via-purple-600 to-indigo-700 rounded-lg flex items-center justify-center shadow group-hover:scale-110 transition-transform duration-300">
                            <FontAwesomeIcon icon={faPlus} className="text-white text-base" />
                          </div>
                          <h4 className="text-base font-bold text-gray-900 group-hover:text-blue-600 transition-colors">
                            {language ? form.en_name : form.ar_name}
                          </h4>
                        </div>
                        {/* Action Button */}
                        <div className="pt-2 mt-auto">
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleClick(form.id, form.en_name, form.ar_name, form.permission, type.reviewee);
                            }}
                            className="w-full bg-gradient-to-r from-blue-500 via-purple-600 to-indigo-700 text-white font-bold py-2 px-4 rounded-full shadow-md hover:shadow-xl transition-all duration-300 hover:scale-105 flex items-center justify-center gap-2 group relative overflow-hidden text-base"
                          >
                            <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
                            <span className="relative z-10">{language ? 'Open Form' : 'فتح النموذج'}</span>
                            <FontAwesomeIcon icon={faArrowRight} className="text-xs group-hover:translate-x-1 transition-transform relative z-10" />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
              {dailyOperations.filter(type => type.id === focusedCardId).map(type => (
                <div
                  key={type.id}
                  ref={focusedCardRef}
                  className={`focused-card-true relative rounded-2xl border border-white/30 bg-gradient-to-br from-white/60 via-blue-100/60 to-white/40 shadow-xl flex flex-col min-w-0 w-full animate-fadeInUp mb-4`}
                  style={{ padding: '1.25rem', alignSelf: 'center', zIndex: 50, pointerEvents: focusExit ? 'none' : 'auto', opacity: focusExit ? 0.7 : 1, backdropFilter: 'blur(10px)' }}
                >
                  {/* Category Header */}
                  <div className="flex items-center gap-3 mb-4">
                    <div className="relative">
                      <div className="w-12 h-12 bg-gradient-to-br from-blue-400/40 to-purple-400/40 backdrop-blur-md rounded-xl flex items-center justify-center shadow border border-white/30">
                        <FontAwesomeIcon icon={WISDOM_PMS_CATEGORY_ICON(type.code)} className="text-2xl text-blue-700 drop-shadow-lg" />
                      </div>
                      <div className="absolute -top-2 -right-2 w-6 h-6 bg-gradient-to-br from-orange-400 to-red-500 rounded-full flex items-center justify-center border border-white shadow animate-pulse">
                        <span className="text-white text-xs font-bold">6</span>
                      </div>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-bold tracking-wide text-blue-900 mb-1 drop-shadow-lg bg-gradient-to-r from-blue-900 to-purple-700 bg-clip-text text-transparent">
                        {language ? type.code : type.codeAr}
                      </h3>
                      <p className="text-xs text-blue-900/80 font-medium leading-relaxed mb-1">
                        {type.description || (language ? 'View and manage forms for this category.' : 'عرض وإدارة النماذج لهذا التصنيف.')}
                      </p>
                    </div>
                  </div>
                  {/* Forms Grid */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {type.forms.map((form, idx) => (
                      <div
                        key={form.id}
                        className="group bg-white/80 backdrop-blur rounded-xl shadow-lg border border-white/40 px-4 py-4 hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 animate-fadeInUp cursor-pointer hover:border-blue-400/60 flex flex-col"
                        style={{ animationDelay: `${idx * 80}ms` }}
                        onClick={() => handleClick(form.id, form.en_name, form.ar_name, form.permission, type.reviewee)}
                      >
                        {/* Form Header */}
                        <div className="flex items-center gap-2 mb-4">
                          <div className="w-8 h-8 bg-gradient-to-br from-blue-500 via-purple-600 to-indigo-700 rounded-lg flex items-center justify-center shadow group-hover:scale-110 transition-transform duration-300">
                            <FontAwesomeIcon icon={faPlus} className="text-white text-base" />
                          </div>
                          <h4 className="text-base font-bold text-gray-900 group-hover:text-blue-600 transition-colors">
                            {language ? form.en_name : form.ar_name}
                          </h4>
                        </div>
                        {/* Action Button */}
                        <div className="pt-2 mt-auto">
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              handleClick(form.id, form.en_name, form.ar_name, form.permission, type.reviewee);
                            }}
                            className="w-full bg-gradient-to-r from-blue-500 via-purple-600 to-indigo-700 text-white font-bold py-2 px-4 rounded-full shadow-md hover:shadow-xl transition-all duration-300 hover:scale-105 flex items-center justify-center gap-2 group relative overflow-hidden text-base"
                          >
                            <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
                            <span className="relative z-10">{language ? 'Open Form' : 'فتح النموذج'}</span>
                            <FontAwesomeIcon icon={faArrowRight} className="text-xs group-hover:translate-x-1 transition-transform relative z-10" />
                          </button>
                        </div>
                      </div>
                    ))}
                    <div
                      key="substitution"
                      className="group bg-white/80 backdrop-blur rounded-xl shadow-lg border border-white/40 px-4 py-4 hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 animate-fadeInUp cursor-pointer hover:border-blue-400/60 flex flex-col"
                      style={{ animationDelay: `${1 * 80}ms` }}
                      onClick={handleTeacherSubstitutionClick}
                    >
                      {/* Form Header */}
                      <div className="flex items-center gap-2 mb-4">
                        <div className="w-8 h-8 bg-gradient-to-br from-blue-500 via-purple-600 to-indigo-700 rounded-lg flex items-center justify-center shadow group-hover:scale-110 transition-transform duration-300">
                          <FontAwesomeIcon icon={faPlus} className="text-white text-base" />
                        </div>
                        <h4 className="text-base font-bold text-gray-900 group-hover:text-blue-600 transition-colors">
                          {language ? "Teacher Substitution" : "الاحتياطي"}
                        </h4>
                      </div>
                      {/* Action Button */}
                      <div className="pt-2 mt-auto">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleTeacherSubstitutionClick();
                          }}
                          className="w-full bg-gradient-to-r from-blue-500 via-purple-600 to-indigo-700 text-white font-bold py-2 px-4 rounded-full shadow-md hover:shadow-xl transition-all duration-300 hover:scale-105 flex items-center justify-center gap-2 group relative overflow-hidden text-base"
                        >
                          <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
                          <span className="relative z-10">{language ? 'Open Form' : 'فتح النموذج'}</span>
                          <FontAwesomeIcon icon={faArrowRight} className="text-xs group-hover:translate-x-1 transition-transform relative z-10" />
                        </button>
                      </div>
                    </div>
                    <div
                      key="latness"
                      className="group bg-white/80 backdrop-blur rounded-xl shadow-lg border border-white/40 px-4 py-4 hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 animate-fadeInUp cursor-pointer hover:border-blue-400/60 flex flex-col"
                      style={{ animationDelay: `${1 * 80}ms` }}
                      onClick={handleTeacherLatnessClick}
                    >
                      {/* Form Header */}
                      <div className="flex items-center gap-2 mb-4">
                        <div className="w-8 h-8 bg-gradient-to-br from-blue-500 via-purple-600 to-indigo-700 rounded-lg flex items-center justify-center shadow group-hover:scale-110 transition-transform duration-300">
                          <FontAwesomeIcon icon={faPlus} className="text-white text-base" />
                        </div>
                        <h4 className="text-base font-bold text-gray-900 group-hover:text-blue-600 transition-colors">
                          {language ? "Teacher Latness" : "تاخير المعلم"}
                        </h4>
                      </div>
                      {/* Action Button */}
                      <div className="pt-2 mt-auto">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleTeacherLatnessClick();
                          }}
                          className="w-full bg-gradient-to-r from-blue-500 via-purple-600 to-indigo-700 text-white font-bold py-2 px-4 rounded-full shadow-md hover:shadow-xl transition-all duration-300 hover:scale-105 flex items-center justify-center gap-2 group relative overflow-hidden text-base"
                        >
                          <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
                          <span className="relative z-10">{language ? 'Open Form' : 'فتح النموذج'}</span>
                          <FontAwesomeIcon icon={faArrowRight} className="text-xs group-hover:translate-x-1 transition-transform relative z-10" />
                        </button>
                      </div>
                    </div>
                    <div
                      key="incident"
                      className="group bg-white/80 backdrop-blur rounded-xl shadow-lg border border-white/40 px-4 py-4 hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 animate-fadeInUp cursor-pointer hover:border-blue-400/60 flex flex-col"
                      style={{ animationDelay: `${1 * 80}ms` }}
                      onClick={handleSchoolIncidentClick}
                    >
                      {/* Form Header */}
                      <div className="flex items-center gap-2 mb-4">
                        <div className="w-8 h-8 bg-gradient-to-br from-blue-500 via-purple-600 to-indigo-700 rounded-lg flex items-center justify-center shadow group-hover:scale-110 transition-transform duration-300">
                          <FontAwesomeIcon icon={faPlus} className="text-white text-base" />
                        </div>
                        <h4 className="text-base font-bold text-gray-900 group-hover:text-blue-600 transition-colors">
                          {language ? "School Incident" : "الوقائع الاشرافية"}
                        </h4>
                      </div>
                      {/* Action Button */}
                      <div className="pt-2 mt-auto">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSchoolIncidentClick();
                          }}
                          className="w-full bg-gradient-to-r from-blue-500 via-purple-600 to-indigo-700 text-white font-bold py-2 px-4 rounded-full shadow-md hover:shadow-xl transition-all duration-300 hover:scale-105 flex items-center justify-center gap-2 group relative overflow-hidden text-base"
                        >
                          <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
                          <span className="relative z-10">{language ? 'Open Form' : 'فتح النموذج'}</span>
                          <FontAwesomeIcon icon={faArrowRight} className="text-xs group-hover:translate-x-1 transition-transform relative z-10" />
                        </button>
                      </div>
                    </div>
                    <div
                      key="attendance"
                      className="group bg-white/80 backdrop-blur rounded-xl shadow-lg border border-white/40 px-4 py-4 hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 animate-fadeInUp cursor-pointer hover:border-blue-400/60 flex flex-col"
                      style={{ animationDelay: `${1 * 80}ms` }}
                      onClick={handleStudentAbsenceClick}
                    >
                      {/* Form Header */}
                      <div className="flex items-center gap-2 mb-4">
                        <div className="w-8 h-8 bg-gradient-to-br from-blue-500 via-purple-600 to-indigo-700 rounded-lg flex items-center justify-center shadow group-hover:scale-110 transition-transform duration-300">
                          <FontAwesomeIcon icon={faPlus} className="text-white text-base" />
                        </div>
                        <h4 className="text-base font-bold text-gray-900 group-hover:text-blue-600 transition-colors">
                          {language ? "Student Absence" : "غياب الطلاب"}
                        </h4>
                      </div>
                      {/* Action Button */}
                      <div className="pt-2 mt-auto">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleStudentAbsenceClick();
                          }}
                          className="w-full bg-gradient-to-r from-blue-500 via-purple-600 to-indigo-700 text-white font-bold py-2 px-4 rounded-full shadow-md hover:shadow-xl transition-all duration-300 hover:scale-105 flex items-center justify-center gap-2 group relative overflow-hidden text-base"
                        >
                          <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
                          <span className="relative z-10">{language ? 'Open Form' : 'فتح النموذج'}</span>
                          <FontAwesomeIcon icon={faArrowRight} className="text-xs group-hover:translate-x-1 transition-transform relative z-10" />
                        </button>
                      </div>
                    </div>
                    <div
                      key="teacher_absence"
                      className="group bg-white/80 backdrop-blur rounded-xl shadow-lg border border-white/40 px-4 py-4 hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 animate-fadeInUp cursor-pointer hover:border-blue-400/60 flex flex-col"
                      style={{ animationDelay: `${1 * 80}ms` }}
                      onClick={() => navigate(`/pms/employee-absence`)}
                    >
                      {/* Form Header */}
                      <div className="flex items-center gap-2 mb-4">
                        <div className="w-8 h-8 bg-gradient-to-br from-blue-500 via-purple-600 to-indigo-700 rounded-lg flex items-center justify-center shadow group-hover:scale-110 transition-transform duration-300">
                          <FontAwesomeIcon icon={faPlus} className="text-white text-base" />
                        </div>
                        <h4 className="text-base font-bold text-gray-900 group-hover:text-blue-600 transition-colors">
                          {language ? "Employee Absence" : "غياب الموظفيين"}
                        </h4>
                      </div>
                      {/* Action Button */}
                      <div className="pt-2 mt-auto">
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate(`/pms/employee-absence`);
                          }}
                          className="w-full bg-gradient-to-r from-blue-500 via-purple-600 to-indigo-700 text-white font-bold py-2 px-4 rounded-full shadow-md hover:shadow-xl transition-all duration-300 hover:scale-105 flex items-center justify-center gap-2 group relative overflow-hidden text-base"
                        >
                          <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
                          <span className="relative z-10">{language ? 'Open Form' : 'فتح النموذج'}</span>
                          <FontAwesomeIcon icon={faArrowRight} className="text-xs group-hover:translate-x-1 transition-transform relative z-10" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              {focusedCardId === "behavior" && <div
                key="studentBehavior"
                ref={focusedCardRef}
                className={`focused-card-true relative rounded-2xl border border-white/30 bg-gradient-to-br from-white/60 via-blue-100/60 to-white/40 shadow-xl flex flex-col min-w-0 w-full animate-fadeInUp mb-4`}
                style={{ padding: '1.25rem', alignSelf: 'center', zIndex: 50, pointerEvents: focusExit ? 'none' : 'auto', opacity: focusExit ? 0.7 : 1, backdropFilter: 'blur(10px)' }}
              >
                {/* Category Header */}
                <div className="flex items-center gap-3 mb-4">
                  <div className="relative">
                    <div className="w-12 h-12 bg-gradient-to-br from-blue-400/40 to-purple-400/40 backdrop-blur-md rounded-xl flex items-center justify-center shadow border border-white/30">
                      <FontAwesomeIcon icon={WISDOM_PMS_CATEGORY_ICON("behavior")} className="text-2xl text-blue-700 drop-shadow-lg" />
                    </div>
                    <div className="absolute -top-2 -right-2 w-6 h-6 bg-gradient-to-br from-orange-400 to-red-500 rounded-full flex items-center justify-center border border-white shadow animate-pulse">
                      <span className="text-white text-xs font-bold">5</span>
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-bold tracking-wide text-blue-900 mb-1 drop-shadow-lg bg-gradient-to-r from-blue-900 to-purple-700 bg-clip-text text-transparent">
                      {language ? "Student Behavior" : "سلوك الطالب"}
                    </h3>
                    <p className="text-xs text-blue-900/80 font-medium leading-relaxed mb-1">
                      {(language ? 'View and manage forms for this category.' : 'عرض وإدارة النماذج لهذا التصنيف.')}
                    </p>
                  </div>
                </div>
                {/* Forms Grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div
                    key="studentBehavior"
                    className="group bg-white/80 backdrop-blur rounded-xl shadow-lg border border-white/40 px-4 py-4 hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 animate-fadeInUp cursor-pointer hover:border-blue-400/60 flex flex-col"
                    style={{ animationDelay: `${1 * 80}ms` }}
                    onClick={handleStudentBehaviorClick}
                  >
                    {/* Form Header */}
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-gradient-to-br from-blue-500 via-purple-600 to-indigo-700 rounded-lg flex items-center justify-center shadow group-hover:scale-110 transition-transform duration-300">
                        <FontAwesomeIcon icon={faPlus} className="text-white text-base" />
                      </div>
                      <h4 className="text-base font-bold text-gray-900 group-hover:text-blue-600 transition-colors">
                        {language ? "Student Behavior" : "سلوك الطالب"}
                      </h4>
                    </div>
                    {/* Action Button */}
                    <div className="pt-2 mt-auto">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleStudentBehaviorClick();
                        }}
                        className="w-full bg-gradient-to-r from-blue-500 via-purple-600 to-indigo-700 text-white font-bold py-2 px-4 rounded-full shadow-md hover:shadow-xl transition-all duration-300 hover:scale-105 flex items-center justify-center gap-2 group relative overflow-hidden text-base"
                      >
                        <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
                        <span className="relative z-10">{language ? 'Open Form' : 'فتح النموذج'}</span>
                        <FontAwesomeIcon icon={faArrowRight} className="text-xs group-hover:translate-x-1 transition-transform relative z-10" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>}
              {focusedCardId === "gradebook" && <div
                key="gradebook"
                ref={focusedCardRef}
                className={`focused-card-true relative rounded-2xl border border-white/30 bg-gradient-to-br from-white/60 via-blue-100/60 to-white/40 shadow-xl flex flex-col min-w-0 w-full animate-fadeInUp mb-4`}
                style={{ padding: '1.25rem', alignSelf: 'center', zIndex: 50, pointerEvents: focusExit ? 'none' : 'auto', opacity: focusExit ? 0.7 : 1, backdropFilter: 'blur(10px)' }}
              >
                {/* Category Header */}
                <div className="flex items-center gap-3 mb-4">
                  <div className="relative">
                    <div className="w-12 h-12 bg-gradient-to-br from-blue-400/40 to-purple-400/40 backdrop-blur-md rounded-xl flex items-center justify-center shadow border border-white/30">
                      <FontAwesomeIcon icon={WISDOM_PMS_CATEGORY_ICON("gradebook")} className="text-2xl text-blue-700 drop-shadow-lg" />
                    </div>
                    <div className="absolute -top-2 -right-2 w-6 h-6 bg-gradient-to-br from-orange-400 to-red-500 rounded-full flex items-center justify-center border border-white shadow animate-pulse">
                      <span className="text-white text-xs font-bold">2</span>
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-bold tracking-wide text-blue-900 mb-1 drop-shadow-lg bg-gradient-to-r from-blue-900 to-purple-700 bg-clip-text text-transparent">
                      {language ? "grade book" : "سجل التقييم"}
                    </h3>
                    <p className="text-xs text-blue-900/80 font-medium leading-relaxed mb-1">
                      {(language ? 'View and manage forms for this category.' : 'عرض وإدارة النماذج لهذا التصنيف.')}
                    </p>
                  </div>
                </div>
                {/* Forms Grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div
                    key="createGradebook"
                    className="group bg-white/80 backdrop-blur rounded-xl shadow-lg border border-white/40 px-4 py-4 hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 animate-fadeInUp cursor-pointer hover:border-blue-400/60 flex flex-col"
                    style={{ animationDelay: `${1 * 80}ms` }}
                    onClick={handleCreateGradebookClick}
                  >
                    {/* Form Header */}
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-gradient-to-br from-blue-500 via-purple-600 to-indigo-700 rounded-lg flex items-center justify-center shadow group-hover:scale-110 transition-transform duration-300">
                        <FontAwesomeIcon icon={faPlus} className="text-white text-base" />
                      </div>
                      <h4 className="text-base font-bold text-gray-900 group-hover:text-blue-600 transition-colors">
                        {language ? "Create Grade Book" : "انشاء سجل تقييم"}
                      </h4>
                    </div>
                    {/* Action Button */}
                    <div className="pt-2 mt-auto">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCreateGradebookClick();
                        }}
                        className="w-full bg-gradient-to-r from-blue-500 via-purple-600 to-indigo-700 text-white font-bold py-2 px-4 rounded-full shadow-md hover:shadow-xl transition-all duration-300 hover:scale-105 flex items-center justify-center gap-2 group relative overflow-hidden text-base"
                      >
                        <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
                        <span className="relative z-10">{language ? 'Open Form' : 'فتح النموذج'}</span>
                        <FontAwesomeIcon icon={faArrowRight} className="text-xs group-hover:translate-x-1 transition-transform relative z-10" />
                      </button>
                    </div>
                  </div>
                  <div
                    key="insertGradebookScore"
                    className="group bg-white/80 backdrop-blur rounded-xl shadow-lg border border-white/40 px-4 py-4 hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 animate-fadeInUp cursor-pointer hover:border-blue-400/60 flex flex-col"
                    style={{ animationDelay: `${1 * 80}ms` }}
                    onClick={handleInsertGradebookScoresClick}
                  >
                    {/* Form Header */}
                    <div className="flex items-center gap-2 mb-4">
                      <div className="w-8 h-8 bg-gradient-to-br from-blue-500 via-purple-600 to-indigo-700 rounded-lg flex items-center justify-center shadow group-hover:scale-110 transition-transform duration-300">
                        <FontAwesomeIcon icon={faPlus} className="text-white text-base" />
                      </div>
                      <h4 className="text-base font-bold text-gray-900 group-hover:text-blue-600 transition-colors">
                        {language ? "Insert Grade Book Score" : "ادخال درجات سجل التقييم"}
                      </h4>
                    </div>
                    {/* Action Button */}
                    <div className="pt-2 mt-auto">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleInsertGradebookScoresClick();
                        }}
                        className="w-full bg-gradient-to-r from-blue-500 via-purple-600 to-indigo-700 text-white font-bold py-2 px-4 rounded-full shadow-md hover:shadow-xl transition-all duration-300 hover:scale-105 flex items-center justify-center gap-2 group relative overflow-hidden text-base"
                      >
                        <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent transform -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
                        <span className="relative z-10">{language ? 'Open Form' : 'فتح النموذج'}</span>
                        <FontAwesomeIcon icon={faArrowRight} className="text-xs group-hover:translate-x-1 transition-transform relative z-10" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Pms;